import { format } from 'date-fns';
import fp from 'lodash/fp';
import { dateFormats } from '../../constants';
import logo from './logo';

const formatDate = (date) => date ? format(new Date(date), dateFormats.LongDate) : '';

const formatReport = (report, minDate, maxDate) =>
  fp.flow(
    fp.filter((x) => x && (!fp.isArray(x) || x.length)),
    fp.join(': ')
  )([
    report,
    fp.flow(
      fp.filter(fp.identity),
      fp.map(formatDate),
      fp.join(' - ')
    )([minDate, maxDate])
  ]);

const reportHeader = ({ report: reportName, reportee, afsl, minDate, maxDate }) => {
  const reportFormat = formatReport(reportName, minDate, maxDate);

  const today = new Date();

  const generatedDateText = `Report Generated: ${format(today, dateFormats.ShortDate)}`;

  const report = [
    ['save'],
    ['rect', [0, 0, 842, 60]],
    ['fill', ['#1fd1a1']],
    ['fillColour', ['#fff']],
    ['save'],
    ['translate', [-30, -18]],
    ['scale', [0.6]],
    ...logo,
    ['restore'],
    ['fontSize', [20]],
    ['font', ['Helvetica']],
    ['text', [reportee, 100, 22, { align: 'center', width: 500 }]],
    ['fontSize', [8]],
    ['text', [generatedDateText, 100, 45, { align: 'center', width: 500 }]],
    ['fontSize', [10]],
    ['text', [reportFormat, 600, 14, { height: 24, width: 242 }]],
    ...(
      afsl ?
        [['text', [`AFSL: ${afsl}`, 600, 38, { height: 24, width: 242 }]]] :
        []
    ),
    ['restore']
  ];

  return report;
};

export default reportHeader;



// WEBPACK FOOTER //
// ./src/reports/partials/report-header.js